import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import deepClone from 'lodash/cloneDeep';
import styled from 'styled-components';
import { useTranslation, withTranslation } from 'react-i18next';
import IconButton from '@material-ui/core/IconButton';
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined';
import UnarchiveOutlinedIcon from '@material-ui/icons/UnarchiveOutlined';
import CustomeAttrDisplay from './customeAttrDisplay';
import ImgIconComp from './imgcomp';
import BarChartComp from './barchart';
import { WbMarkdownHtml, sanitize } from '../utils/common';
import IconCountComp from './iconcount';
import GanttChartComp from '../resources/gantt';
import {
  HEALTH_GOOD, HEALTH_OK, HEALTH_RISK,
  PACE_FAST, PACE_SLOW, PACE_STEADY,
  PORIORITY_P4, PORIORITY_P1, PORIORITY_P2, PORIORITY_P3, PORIORITY_P5,
} from '../resources/component';
import { getAiTypeActionAttributeValueIcon } from '../board/utils';
import { RAG_RED, STATE_DOING } from '../constants/shared_board.constants';
import { useOnClickOutside } from '../hooks/useOnClickOutside';
const IconWrapper = styled.div`
  svg {
    vertical-align: text-bottom;
  }
`;
/* team summary react compnets */
// define constants
const WS_NAME_CHANGE = 'WS_NAME_CHANGE';
const WS_OWNER_CHANGE = 'WS_OWNER_CHANGE';
const WS_LEAD_CHANGE = 'WS_LEAD_CHANGE';
const WS_START_DATE_CHANGE = 'WS_START_DATE_CHANGE';
const WS_END_DATE_CHANGE = 'WS_END_DATE_CHANGE';
const WS_HEALTH_CHANGE = 'WS_HEALTH_CHANGE';
const WS_PRIORITY_CHANGE = 'WS_PRIORITY_CHANGE';
const WS_PACE_CHANGE = 'WS_PACE_CHANGE';
const WS_GOAL_CHANGE = 'WS_GOAL_CHANGE';
const WS_CHART_DATE_INVALID = 'WS_CHART_DATE_INVALID'; // update the chart date valid or not

// define action types
const WsNameChange = item => ({ type: WS_NAME_CHANGE, value: item });
const WsOwnerChange = item => ({ type: WS_OWNER_CHANGE, value: item });
const WsLeadChange = item => ({ type: WS_LEAD_CHANGE, value: item });
const WsStartDateChange = item => ({ type: WS_START_DATE_CHANGE, value: item });
const WsEndDateChange = item => ({ type: WS_END_DATE_CHANGE, value: item });
const WsHealthChange = item => ({ type: WS_HEALTH_CHANGE, value: item });
const WsPriorityChange = item => ({ type: WS_PRIORITY_CHANGE, value: item });
const WsPaceChange = item => ({ type: WS_PACE_CHANGE, value: item });
const WsGoalChange = item => ({ type: WS_GOAL_CHANGE, value: item });
const WsChartDateInvalid = item => ({ type: WS_CHART_DATE_INVALID, value: item });

// define reducers
const TeamSummaryReducer = (state = {}, action) => {
  const initState = state;
  switch (action.type) {
    case WS_NAME_CHANGE: // update ws name in redux
      initState.ganttTasks = initState.ganttTasks.map((item) => {
        if (item.id == action.value.id) {
          item.name = action.value.name;
        }
        return item;
      });
      initState.wsLists = initState.wsLists.map((item) => {
        if (item.wsId == action.value.id) {
          item.dataWs.name = action.value.name;
          item.dataWs.name_truncate = action.value.name_truncate;
        }
        return item;
      });
      state = { ...state, initState };
      break;

    case WS_LEAD_CHANGE: // update ws lead name in redux
      initState.wsLists = initState.wsLists.map((item) => {
        if (item.wsId == action.value.id) {
          item.dataWs.leadName = action.value.leadName;
          item.dataWs.leadImagePath = action.value.leadImagePath;
        }
        return item;
      });
      state = { ...state, initState };
      break;

    case WS_OWNER_CHANGE: // update ws owner in redux
      initState.wsLists = initState.wsLists.map((item) => {
        if (item.wsId == action.value.id) {
          item.dataWs.owner = action.value.owner;
        }
        return item;
      });
      state = { ...state, initState };
      break;

    case WS_START_DATE_CHANGE: // update ws start date in redux
      if (action.value.chartUpdate) {
        initState.ganttTasks = initState.ganttTasks.map((item) => {
          if (item.id == action.value.id) {
            item.data[0].start = action.value.startDate;
          }
          return item;
        });
      }
      initState.wsLists = initState.wsLists.map((item) => {
        if (item.wsId == action.value.id) {
          item.dataWs.start_date = action.value.startDate;
        }
        return item;
      });
      state = { ...state, initState };
      break;

    case WS_END_DATE_CHANGE: // update ws end date in redux
      if (action.value.chartUpdate) {
        initState.ganttTasks = initState.ganttTasks.map((item) => {
          if (item.id == action.value.id) {
            item.data[0].end = action.value.endDate;
            if (action.value.endDate) {
              item.data[0].ws_target_date = action.value.endDate;
            }
          }
          return item;
        });
      }
      initState.wsLists = initState.wsLists.map((item) => {
        if (item.wsId == action.value.id) {
          item.dataWs.target_date = action.value.endDate;
        }
        return item;
      });
      state = { ...state, initState };
      break;
    case WS_CHART_DATE_INVALID: // update chart date invalid or not
      initState.ganttTasks = initState.ganttTasks.map((item) => {
        if (item.id == action.value.id) {
          item.data[0].invalid = action.value.invalid;
          item.data[0].end = action.value.endDate;
          item.data[0].start = action.value.startDate;
          item.data[0].ws_target_date = action.value.ws_target_date;
        }
        return item;
      });

      state = { ...state, initState };
      break;

    case WS_HEALTH_CHANGE: // update ws helth in redux

      initState.ganttTasks = initState.ganttTasks.map((item) => {
        if (item.id == action.value.id) {
          item.data[0].class = `bar-${action.value.healthName.toLowerCase()}`;
        }
        return item;
      });
      initState.wsLists = initState.wsLists.map((item) => {
        if (item.wsId == action.value.id) {
          item.dataWs.health = action.value.health;
          item.dataWs.healthName = action.value.healthName;
          item.dataWs.healthImage = action.value.healthImage;
          item.dataWs.color = action.value.color;
        }
        return item;
      });
      state = { ...state, initState };
      break;

    case WS_PRIORITY_CHANGE: // update ws priority in redux
      initState.wsLists = initState.wsLists.map((item) => {
        if (item.wsId == action.value.id) {
          item.dataWs.priorityText = action.value.priorityText;
          item.dataWs.priority = action.value.priority;
        }
        return item;
      });
      state = { ...state, initState };
      break;

    case WS_PACE_CHANGE: // update ws pace in redux
      initState.wsLists = initState.wsLists.map((item) => {
        if (item.wsId == action.value.id) {
          item.dataWs.pace = action.value.pace;
          item.dataWs.paceText = action.value.paceText;
        }
        return item;
      });
      state = { ...state, initState };
      break;

    case WS_GOAL_CHANGE: // update ws goal in redux
      initState.wsLists = initState.wsLists.map((item) => {
        if (item.wsId == action.value.id) {
          item.dataWs.goal = action.value.goalData;
        }
        return item;
      });
      state = { ...state, initState };
      break;
  }
  return state;
};

export const teamSummaryViewComp = function (props) {
  const mapsStateToPropsForTeamws = state => ({
    teamws: state,
  });
  const actions = {
    WsNameChange, WsOwnerChange, WsLeadChange, WsStartDateChange, WsEndDateChange, WsHealthChange, WsPriorityChange, WsPaceChange, WsGoalChange, WsChartDateInvalid,
  };
  const mapsDispatchToPropsForTeamws = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  });

  const teamwsStore = createStore(TeamSummaryReducer, props);
  const TeamwsAppComp = connect(
    mapsStateToPropsForTeamws,
    mapsDispatchToPropsForTeamws,
  )(withTranslation()(TeamSummaryTap));
  const ExtendedComponent = withTranslation()(TeamwsAppComp);
  ReactDOM.render(
    <Provider store={teamwsStore}>
      <ExtendedComponent />
    </Provider>,
    document.getElementById('teamSummaryTab'),
  );
};
/* Top tab */
class TeamSummaryTap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.teamws.wsLists,
      ganttTasks: this.props.teamws.ganttTasks,
      selTab: 'narative',
    };
    this.clickNarative = this.clickNarative.bind(this);
    this.clickTimeLine = this.clickTimeLine.bind(this);
  }

  componentDidMount() {
    // this.clickTimeLine(this);
    this.clickNarative(this);
  }

  clickNarative() {
    $('.timeLine').removeClass('tabActive');
    $('.narative').addClass('tabActive');
    ReactDOM.render(<TeamSummaryNarativeComp
      items={this.state.items}
      actions={this.props.actions}
      teamId={this.props.teamws.teamId}
      teamWsFilters={this.props.teamws.teamWsFilters}
      t={this.props.t}
      />, document.getElementById('summary-persentage')
    );
  }

  clickTimeLine() {
    $('.narative').removeClass('tabActive');
    $('.timeLine').addClass('tabActive');
    ReactDOM.render(<TeamSummaryTimeLineComp items={this.state.items} ganttTasks={this.state.ganttTasks} actions={this.props.actions} />, document.getElementById('summary-persentage'));
  }

  render() {
    const { t } = this.props;
    const { selTab } = this.state;
    return (
      <div className="summeryTabWrap">
        <div className="teamSummeryTab narative" onClick={e => this.clickNarative(this)} role="button" tabIndex="0" aria-label="Narrative">
          <div className="tabIcon left">
            {<ImgIconComp id="narrative" width="12" height="10" />}
          </div>
          <div className="tabText">{t("Narrative")}</div>
        </div>
      </div>
    );
  }
}

/* team summary Comp */
class TeamSummaryTimeLineComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      par_items: this.props.items,
      ganttTasks: this.props.ganttTasks,
    };
    this.ganttConfig = this.ganttConfig.bind(this);
    this.ws_sorting = this.ws_sorting.bind(this);
    this.on_date_change = this.on_date_change.bind(this);
    this.on_task_list_name = this.on_task_list_name.bind(this);
    this.on_show_details = this.on_show_details.bind(this);
    this.showLegend = this.showLegend.bind(this);
    this.hideLegend = this.hideLegend.bind(this);
    this.draw = this.draw.bind(this);
    this.wsNameClick = this.wsNameClick.bind(this);
  }

  componentDidMount() {
    this.mountId = document.getElementById('chartData');
    resizeBoardGanttCharts();
    this.draw();
  }

  ganttConfig() {
    let view_mode = 'Week';
    if ($('#gantt-timescale').length) {
      const timescaleMode = $('#gantt-timescale').attr('data-value');
      if (timescaleMode !== 'undefined') {
        view_mode = timescaleMode.charAt(0).toUpperCase() + timescaleMode.substr(1).toLowerCase();
      }
    }
    let sortingId = 'asc';
    if ($('#gantt-sorting').length) {
      const sortingView = $('#gantt-sorting').attr('data-value');
      if (sortingView !== 'undefined') {
        sortingId = sortingView;
      }
    }
    return {
      svg_class: 'svg-class',
      task_list_width: 1,
      padding: 30,
      header_height: 50,
      bar: {
        height: 20,
        corner_radius: 2.5,
        draggable: canEditAttribute,
        expandable: canEditAttribute,
      },
      // column_width : 25,
      show_label: true,
      render_task_list: 'teamws-task-name-wrapper',
      maximum_year: false,
      view_mode,
      sorting: {
        enabled: true,
        id: sortingId,
        items: [{ id: 'asc', title: 'A to Z' }, { id: 'desc', title: 'Z to A' }, { id: 'priority', title: 'Priority' }, { id: 'startDate', title: 'Start date' }, { id: 'endDate', title: 'End date' }],
        filters: this.ws_sorting,
      },
      hover_date_show: true, // show date in hover of name

    };
  }

  ws_sorting(tasks, sortingId) {
    switch (sortingId) {
      case 'asc':
        tasks = tasks.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'desc':
        tasks = tasks.sort((a, b) => b.name.localeCompare(a.name));
        break;

      case 'priority':
        tasks = tasks.sort((a, b) => a.data[0].priority - b.data[0].priority);
        break;

      case 'startDate':
        tasks = tasks.sort((a, b) => a.data[0].start - b.data[0].start);
        break;

      case 'endDate':
        tasks = tasks.sort((a, b) => a.data[0].ws_target_date - b.data[0].ws_target_date);
        break;

      default:
        break;
    }
    return tasks;
  }

  on_date_change(task, startdate, enddate) {
    const _this = this;
    const endDate = enddate.format('MM/DD/YY');
    const startDate = startdate.format('MM/DD/YY');
    const start_date = startdate.format('MMM DD, YYYY');
    const end_date = enddate.format('MMM DD, YYYY');
    $(`.task-${task.id}`).html(`${start_date} - ${end_date}`);
    const param = {
      id: task.id, start_date: startDate, target_date: endDate, calender: 1,
    };
    showLoaderWidget($('#content'));
    const gantChart = _this.state.ganttTasks;
    const { par_items } = _this.state;
    const items = par_items.map((item, index) => {
      if (item.wsId == task.id) {
        item.dataWs.start_date = moment(startdate).format('X');
        item.dataWs.target_date = moment(enddate).format('X');
      }
      return item;
    });
    const wsUpdate = Object.assign(_this.state.par_items, items);

    _this.props.actions.WsStartDateChange({ id: task.id, startDate: moment(startdate).format('X'), chartUpdate: true });
    _this.props.actions.WsEndDateChange({ id: task.id, endDate: moment(enddate).format('X'), chartUpdate: true });

    $.post(`${wbConfig.baseUrl}/activity/updateAllWsAttribute`, param, (data, status) => {
      //           let ganttTasks = gantChart.map((chart,index) => {
      //                if(chart.id === task.id){
      //                    chart.data[0].end = moment(enddate).format('X');
      //                    chart.data[0].start = moment(startdate).format('X');
      //                }
      //             return chart;
      //            });
      //            _this.setState({
      //                ganttTasks : ganttTasks,
      //            })
      removeLoaderWidget();
    });
  }

  on_task_list_name(task, index) {
    this.on_show_details(task);
  }

  on_show_details(task) {
    if (typeof task !== 'undefined' && typeof task.id !== 'undefined') {
      const obj = this.state.par_items;
      const item = obj.find(o => o.wsId === task.id);
      wsEditPopup.dialogOpen();
      if (document.getElementById('wsEditPopup')) {
        ReactDOM.unmountComponentAtNode(document.getElementById('wsEditPopup'));
      }
      setTimeout(
        () => ReactDOM.render(<ViewWsPopupComp item={item} actions={this.props.actions} draw={this.draw} chartTasks={this.props.ganttTasks} />, document.getElementById('wsEditPopup')),
        1000
      );
    }
  }

  showLegend() {
    $('.ws-summary-gantt-legend-wrapper').show();
  }

  hideLegend() {
    $('.ws-summary-gantt-legend-wrapper').hide();
  }

  /* gant chart drowing */
  draw() {
    const { t } = this.props;
    const { ganttTasks } = this.state;
    const ganttConfig = this.ganttConfig();
    const ganttEvents = {
      on_date_change: this.on_date_change,
      on_show_details: this.on_show_details,
      on_task_list_name: this.on_task_list_name,
    };
    ReactDOM.unmountComponentAtNode(this.mountId);
    ReactDOM.render(
      <div>
        <div className="lengentWeap">
          <div className="ws-summary-gantt-chart-legend clickable" onClick={() => this.showLegend()}>Legend</div>
          <div className="ws-summary-gantt-legend-wrapper">
            <div className="width100 gantt-legend-header">
              <div className="gantt-legend-header-text">Legend</div>
              <div className="gantt-legend-header-icon clickable" onClick={() => this.hideLegend()}><ImgIconComp id="close" width="10" height="11" /></div>
            </div>
            <div className="width100 gantt-legend-content">
              <div className="gantt-legend-good">
                <span className="gantt-legend-circle" />
                <span>
                {t("Project health is")}
                  <b>{t("good")}</b>
                </span>
              </div>
              <div className="gantt-legend-ok">
                <span className="gantt-legend-circle" />
                <span>
                {t("Project health is")}
                  <b>{t("Ok")}</b>
                </span>
              </div>
              <div className="gantt-legend-risk">
                <span className="gantt-legend-circle" />
                <span>
                {t("Project health is")}
                  <b>{t("at risk")}</b>
                </span>
              </div>
              <div className="gantt-legend-notset">
                <span className="gantt-legend-circle" />
                <span>{t("Project time period not set")}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="left">
          <div id="teamws-task-name-wrapper" className="left" />
          <GanttChartComp config={ganttConfig} tasks={ganttTasks} events={ganttEvents} class="ws-summary-gantt-chart-wrapper" />
        </div>
      </div>,
      this.mountId,
    );
  }

  wsNameClick(id, e) {
    // $('#workstream_' + id).trigger('click');
    const wsUrl = `${wbConfig.baseUrl}/activity/workstreams?id=${id}`;
    triggerLeftMenu(wsUrl, false, 'menu-board', () => {
      document.title = 'Board';
      activeTopMenuId('board');
    });

    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }

  render() {
    return (
      <div id="chartData" />
    );
  }
}
/* end timeline */

const TeamWsFilterDropdownWrapper = styled.div`
  display: flex;
  gap: 5px;
  .sort-popupover {
    margin-top: 25px;
    margin-left: 30px;
  }
  .show-popupover {
    margin-top: 25px;
    margin-left: 30px;
  }
`;

const TeamWsFilterDropdownBox = styled.div`
color: #2c9ab7;
`;

const TeamWsSortOptions = [
  {
    label: 'A to Z',
    value: 'asc'
  },
  {
    label: 'Z to A',
    value: 'desc'
  },
  {
    label: 'Priority',
    value: 'priority'
  },
  {
    label: 'Start date',
    value: 'startDate'
  },
  {
    label: 'End date',
    value: 'endDate'
  }
];

const DEFAULT_WS_STATUS = 1; // Active

const TeamWsStatusOptions = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'Active',
    value: 1
  },
  {
    label: 'Archived',
    value: 0
  }
];

const TeamWorkstreamFilterDropdown = ({
  name,
  label,
  value,
  options,
  onChange
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [wrapperRef] = useOnClickOutside(() => {
    setIsOpen(false);
  });
  const { t } = useTranslation();

  const onChangeEvent = (e, option) => {
    e.preventDefault();
    setIsOpen(false);
    onChange(option);
  }

  const selectedOption = options.filter((option) => option.value == value);
  const selectedText = selectedOption?.[0]?.label ?? options?.[0]?.label ?? '';

  return (
    <>
      <TeamWsFilterDropdownWrapper>
        <div>{label}:</div>
        <TeamWsFilterDropdownBox
          onClick={e => setIsOpen(true)}
          role="button"
          tabIndex="0"
          aria-label={label}
        >
          <div style={{ cursor: 'pointer' }}>
            <span>{t(selectedText)}</span>
            <span className="timescale-icon" />
          </div>
        </TeamWsFilterDropdownBox>
        { isOpen && (
          <div
            ref={wrapperRef}
            className={` gantt-dropdown-popup shadow sortClick ${name}-popupover`}
            >
            { options.map((option) => (
              <div
                key={`${name}_${option.value}`}
                className="gantt-dp-item clickable"
                onClick={(e) => onChangeEvent(e, option)}
              >
                {t(option.label)}
              </div>
            ))}
          </div>
          )}
      </TeamWsFilterDropdownWrapper>
    </>
  )
}

/* Narative tab comp */
class TeamSummaryNarativeComp extends React.Component {
  constructor(props) {
    super(props);
    const { items, teamWsFilters } = this.props;
    this.state = {
      par_items: items,
      noteShow: [],
      sortPopup: false,
      popupShow: 'null',
      isEditor: false,
      defSort: teamWsFilters?.defSort ?? 'asc',
      defStatus: teamWsFilters?.defStatus ?? DEFAULT_WS_STATUS,
  	  hoveredRowId: null, // Track the hovered row

    };
    this.initNoteStatus = this.initNoteStatus.bind(this);
    this.dataPikerInt = this.dataPikerInt.bind(this);
    this.clickDate = this.clickDate.bind(this);
    this.selectDueDate = this.selectDueDate.bind(this);
    this.selectStartDate = this.selectStartDate.bind(this);
    this.wsNameClick = this.wsNameClick.bind(this);
    this.togleNote = this.togleNote.bind(this);
    this.cKeditorLoad = this.cKeditorLoad.bind(this);
    this.updateWsAttributes = this.updateWsAttributes.bind(this);
    this.updateGoal = this.updateGoal.bind(this);
    this.remainingDays = this.remainingDays.bind(this);
    this.getWsProgressColor = this.getWsProgressColor.bind(this);
    this.selectPace = this.selectPace.bind(this);
    this.selectHealt = this.selectHealt.bind(this);
    this.selectPriority = this.selectPriority.bind(this);
    this.popupClick = this.popupClick.bind(this);
    this.wsNameSorting = this.wsNameSorting.bind(this);
    this.clickable = this.clickable.bind(this);
    this.goalShowDiv = this.goalShowDiv.bind(this);
    this.goalTextClick = this.goalTextClick.bind(this);
    this.onChangeWsSorting = this.onChangeWsSorting.bind(this);
    this.onChangeStatus = this.onChangeStatus.bind(this);
    this.filteredDataItems = this.filteredDataItems.bind(this);
    this.saveTeamWsFilters = this.saveTeamWsFilters.bind(this);
		this.onRowHover = this.onRowHover.bind(this);
    this.onRowLeave = this.onRowLeave.bind(this);
    this.onArchive = this.onArchive.bind(this);
  }

  componentDidMount() {
    showLoaderWidget($('#content'));
    resizeHeaderSction();
    this.initNoteStatus();
    removeLoaderWidget();
  }


  initNoteStatus() {
    const contentdata = this.props.items.map((item) => {
      item.noteShow = 0;
      return item;
    });
    this.setState({
      par_items: contentdata,
    });
  }

  dataPikerInt(DivId, wsId, limitDate, type) {
    const this_ = this;

    this.datepicker = $(`#${DivId}`);
    if (type == 'startDate_') {
      $(this.datepicker).datepicker({
        showAnim: 'slide',
        dateFormat: 'M dd, yy',
        maxDate: limitDate,
        onSelect(date) {
          this_.selectStartDate(date, wsId);
        },
        onChangeMonthYear(year, month, inst) {
          const buttonPane = $(inst.input).datepicker('widget');
          $(buttonPane).find('button.newStyleForDatePicker').remove();
          setTimeout(() => {
            const btn = $('<button class=" clearstyles newStyleForDatePicker" type="button">Clear</button>');
            btn
              .off('click')
              .on('click', () => {
                $.datepicker._clearDate(inst.input);
              });
            if ($('.wbmodal-datepicker .newStyleForDatePicker').length == 0) {
              btn.appendTo(buttonPane);
            }
          }, 1);
        },
        beforeShow(input, inst) {
          $('#ui-datepicker-div').addClass('dataTimePicker wbmodal-datepicker');
          inst.dpDiv.css({
            marginLeft: '-95px',
          });
          setTimeout(() => {
            const buttonPane = $(input).datepicker('widget');
            const btn = $('<button class=" clearstyles newStyleForDatePicker" type="button" >Clear</button>');
            btn
              .off('click')
              .on('click', () => {
                $.datepicker._clearDate(input);
              });
            if ($('.wbmodal-datepicker .newStyleForDatePicker').length == 0) {
              btn.appendTo(buttonPane);
            }
          }, 1);
        },
      });
    } else {
      // dateLimit = 'maxDate:'+limitDate;
      $(this.datepicker).datepicker({
        showAnim: 'slide',
        dateFormat: 'M dd, yy',
        minDate: limitDate,
        onSelect(date) {
          //  if(type == 'startDate_'){
          //     this_.selectStartDate(date,wsId);
          // }else{
          this_.selectDueDate(date, wsId);
          // }
        },
        onChangeMonthYear(year, month, inst) {
          const buttonPane = $(inst.input).datepicker('widget');
          $(buttonPane).find('button.newStyleForDatePicker').remove();
          setTimeout(() => {
            const btn = $('<button class=" clearstyles newStyleForDatePicker" type="button">Clear</button>');
            btn
              .off('click')
              .on('click', () => {
                $.datepicker._clearDate(inst.input);
              });
            if ($('.wbmodal-datepicker .newStyleForDatePicker').length == 0) {
              btn.appendTo(buttonPane);
            }
          }, 1);
        },
        beforeShow(input, inst) {
          $('#ui-datepicker-div').addClass('dataTimePicker wbmodal-datepicker');
          inst.dpDiv.css({
            marginLeft: '-130px',
          });
          setTimeout(() => {
            $('#ui-datepicker-div').css('left', '1100px');
            const buttonPane = $(input).datepicker('widget');
            const btn = $('<button class=" clearstyles newStyleForDatePicker" type="button" >Clear</button>');
            btn
              .off('click')
              .on('click', () => {
                $.datepicker._clearDate(input);
              });
            if ($('.wbmodal-datepicker .newStyleForDatePicker').length == 0) {
              btn.appendTo(buttonPane);
            }
          }, 1);
        },
      });
    }
    $(`#${DivId}`).datepicker('show');
  }

  clickDate(wsId, dateLimit, type, canEditAttribute) {
    if (canEditAttribute) {
      let LimitDate = '';
      if (dateLimit) {
        LimitDate = moment.unix(dateLimit).format('MMM DD, YYYY');
      }
      const DivId = type + wsId;
      this.dataPikerInt(DivId, wsId, LimitDate, type);
    }
  }

  selectDueDate(date, id) {
    let date_ = '';
    date_ = date ? Date.parse(date) / 1000 : '';
    const dateS = date ? moment.unix(date_).format('M/D/Y') : null;
    this.props.actions.WsEndDateChange({ id, endDate: date_, chartUpdate: true });
    this.forceUpdate();
    this.updateWsAttributes(id, dateS, 'target_date');
  }

  selectStartDate(date, id) {
    let date_ = '';
    date_ = date ? Date.parse(date) / 1000 : '';
    const dateS = date ? moment.unix(date_).format('M/D/Y') : null;
    this.props.actions.WsStartDateChange({ id, startDate: date_, chartUpdate: true });
    this.forceUpdate();
    this.updateWsAttributes(id, dateS, 'start_date');
  }

  wsNameClick(id, e) {
    const wsUrl = `${wbConfig.baseUrl}/activity/workstreams?id=${id}`;
    triggerLeftMenu(wsUrl, false, 'menu-board', () => {
      document.title = 'Board';
      activeTopMenuId('board');
    });
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }

  togleNote(noteShow, wsId) {
    const show = noteShow == 1 ? '0' : '1';
    const eleIdB = `editDisc_${wsId}`;
    const instance = CKEDITOR.instances[eleIdB];
    if (show == 1) {
      $(`.arrow_down_${wsId}`).hide();
      $(`.arrow_up_${wsId}`).show();
      $(`.editNote_${wsId}`).show();
      $(`.pencil_${wsId}`).show();
      if ($(`#editDisc_${wsId}`).html() == '' || $(`#editDisc_${wsId}`).html() == 'undefined') {
        $(`.noGoalDesc_${wsId}`).show();
      }
      $(`.narative_border_${wsId}`).children().removeClass('border_bottom');
      $(`.noteDiv_${wsId}`).addClass('border_bottom');
      //            if($('.editDisc_'+wsId > '.pencil_'+wsId).length == 0 ){
      //                $('.editDisc_'+wsId).append($('.pencil_'+wsId))
      //            }
    } else {
      $(`.narative_border_${wsId}`).children().addClass('border_bottom');
      $(`.noteDiv_${wsId}`).removeClass('border_bottom');
      /* Distroy ckEditoe */
      if (instance) {
        CKEDITOR.instances[eleIdB].destroy();
        if ($(`#editDisc_${wsId}`).html() == '' || $(`#editDisc_${wsId}`).html() == 'undefined') {
          $(`.noGoalDesc_${wsId}`).show();
        }
      }
      $(`.arrow_down_${wsId}`).show();
      $(`.arrow_up_${wsId}`).hide();
      $(`.editNote_${wsId}`).hide();
    }
    const contentdata = this.props.items.map((item) => {
      if (item.wsId == wsId) {
        item.noteShow = show;
      }
      return item;
    });
    this.setState({
      par_items: contentdata,
    });
  }

  cKeditorLoad(canEditAttribute, id) {
    const _this = this;
    if (canEditAttribute) {
      _this.setState({
        isEditor: true,
      });
      $(`.noGoalDesc_${id}`).hide();
      $(`.Npencil_${id}`).hide();
      $(`.pencil_${id}`).hide();
      const eleIdB = `editDisc_${id}`;
      $(`.editDisc_${id}`).hide();
      CKEDITOR.disableAutoInline = true;
      CKEDITOR.timestamp = css_js_version_control;
      const wsGoalEditorV = CKEDITOR.replace(eleIdB, {
        extraAllowedContent: 'a(documentation);abbr[title];code',
        startupFocus: true,
        // removePlugins: 'magicline,liststyle,tabletools,scayt,contextmenu,elementspath,forms',
        extraPlugins: 'chkstrike,confighelper,linkclickable,autogrow,pasteFromGoogleDoc',
        // uploadUrl: '/uploader/upload.php',
        autoGrow_onStartup: false,
        resize_enabled: false,
        height: '100px',
        autoGrow_maxHeight: 100,
        autoGrow_bottomSpace: 0,
        line_height: '8px',
        sharedSpaces: {
          top: 'top2',
        },
        fillEmptyBlocks: false,
        shiftEnterMode: CKEDITOR.ENTER_BR,
        enterMode: CKEDITOR.ENTER_BR,
        allowedContent: true,
        entities: false,
        basicEntities: false,
      });
      wsGoalEditorV.on('instanceReady', (ev) => {
        ev.editor.focus();
        const s = ev.editor.getSelection(); // getting selection
        let selected_ranges = s.getRanges(); // getting ranges
        let node = selected_ranges[0].startContainer; // selecting the starting node
        while (true) {
          const x = node.getNext();
          if (x == null) {
            break;
          }
          node = x;
        }
        s.selectElement(node);
        selected_ranges = s.getRanges();
        selected_ranges[0].collapse(false); //  false collapses the range to the end of the selected node, true before the node.
        s.selectRanges(selected_ranges); // putting the current selection there
      });
      wsGoalEditorV.on('blur', () => {
        const content = wsGoalEditorV.getData();
        _this.updateGoal(content, id);
      });
    }
  }

  updateWsAttributes(id, source_val, source) {
    /* save updated values in DB */
    showLoaderWidget($('#content'));
    const this_ = this;
    this_.forceUpdate();
    const param = { id, source_val, source };
    $.post(`${wbConfig.baseUrl}/tag/updateWsAttribute`, param, (data, status) => {
      removeLoaderWidget();
    });
  }

  updateGoal(goal, id) {
    goal = sanitize(urlify(goal));
    let edit = true;
    const this_ = this;
    const goal_ = (goal) || '';
    this.state.par_items.map((item) => {
      if (item.wsId == id) {
        if (item.dataWs.goal.localeCompare(goal_) != 0) {
          edit = false;
        }
      }
    });

    /* save updated values in DB */
    const eleIdB = `editDisc_${id}`;
    const instance = CKEDITOR.instances[eleIdB];
    if (instance) {
      CKEDITOR.instances[eleIdB].destroy();

      if (!$.trim(goal)) {
        $(`.noGoalDesc_${id}`).show();
        $(`.Npencil_${id}`).show();
      } else {
        $(`.editDisc_${id}`).show();
        $(`.pencil_${id}`).show();
      }
    }
    // if(edit){
    this_.props.actions.WsGoalChange({ id, goalData: goal });
    this_.forceUpdate();
    showLoaderWidget($('#content'));
    const param = { id, source_val: goal_, source: 'goal' };
    $.post(`${wbConfig.baseUrl}/tag/updateWsAttribute`, param, (data, status) => {
      removeLoaderWidget();
    });
    //  }
  }

  remainingDays(startDate, endData) { // calcualting remaing week
    if ((!startDate) || (!endData)) {
      return;
    }
    const today = moment();
    const start = moment.unix(startDate);
    const end = moment.unix(endData);
    const tot_days = (end.diff(start, 'days')) % 7;
    let tot_weeks = end.diff(start, 'weeks');
    const rem_days = end.diff(today, 'days') + 1;
    let rem_weeks = parseInt(rem_days / 7);// end.diff(today, 'weeks');
    rem_weeks = (rem_weeks < 0) ? 0 : rem_weeks;
    tot_weeks = (tot_weeks < 0) ? 0 : tot_weeks;
    const return_ = `${rem_weeks} of ${tot_weeks}${(tot_days != 0) ? `.${tot_days}` : ' '} Weeks Remaining`;
    return return_;
  }

  getWsProgressColor(health) {
    let pColor;
    switch (health.toString()) {
      case '1' || 1 || '1':
        pColor = '#339933';
        break;
      case '2' || 2 || '2':
        pColor = '#476C89';
        break;
      case '3' || 3 || '3':
        pColor = '#db3a1b';
        break;
      default:
        pColor = '#476C89';
        break;
    }
    return pColor;
  }

  selectPace(paceText, paceVal, id) {
    const _this = this;
    setTimeout(() => _this.setState({
      paceText,
      pace: paceVal,
      actionDone: true,
      popupShow: 'null',
    }), 10);
    this.updateWsAttributes(id, paceVal, 'pace');
    this.props.actions.WsPaceChange({ id, pace: paceVal, paceText });
  }

  selectHealt(healthName, healthImage, health, id) {
    const color = this.getWsProgressColor(health); // get heath color
    this.setState({
      healthName,
      healthImage,
      health,
      popupShow: 'null',
    });
    this.updateWsAttributes(id, health, 'health');
    this.props.actions.WsHealthChange({
      id, health, healthName, healthImage, color,
    });
  }

  selectPriority(proText, proValue, id) {
    this.setState({
      priorityText: proText,
      priority: proValue,
      popupShow: 'null',
    });
    this.updateWsAttributes(id, proValue, 'priority');
    this.props.actions.WsPriorityChange({ id, priority: proValue, priorityText: proText });
  }

  popupClick(item, type) {
    const _this = this;
    setTimeout(() => _this.setState({
      popupShow: `${type}_${item.id}`,
    }), 10);
  }

  saveTeamWsFilters (param) {
    const { teamId } = this.props;
    const { defSort, defStatus } = this.state;
    $.post(`${wbConfig.baseUrl}/team/saveTeamWorkstreamPreferences`, {
      teamId,
      data: {
        defSort,
        defStatus
      }
    });
  }

  onChangeWsSorting (option) {
    this.wsNameSorting(option.value);
  }

  onChangeStatus (option) {
    this.setState({
      defStatus: option.value
    }, () => {
      // callback api
      this.saveTeamWsFilters();
    });
  }

  wsNameSorting (type) {
    this.setState({
      defSort: type,
    }, () => {
      this.saveTeamWsFilters();
    });
  }

  clickable(canEdit) {
    if (canEdit) {
      return 'clickable';
    }
    return 'nonClickable';
  }

  goalShowDiv(goal, canEdit, id) {
    const { t } = this.props;
    if ($.trim(goal)) {
      return (
        <div className="isGoalData">
          { (canEdit)
                    && <img className={`pencilImage pencil_${id}`} width="15px" src={`${wbConfig.imageCdnUrl}/images/goal/pencil.png`} onClick={e => this.cKeditorLoad(canEdit, id)} />
                }
        </div>
      );
    }
    return (
      <div className="isNoGoal">
        <div className={`noGoalDesc noGoalDesc_${id}`} onClick={e => this.cKeditorLoad(canEdit, id)}>{t("Describe the purpose of this workstream, update the team on progress or communicate news about it")}.</div>
        { (canEdit)
                    && <img className={`pencilImage Npencil_${id}`} width="15px" src={`${wbConfig.imageCdnUrl}/images/goal/pencil.png`} onClick={e => this.cKeditorLoad(canEdit, id)} />
                }
      </div>
    );
  }

  goalTextClick(e, goal) {
    e.preventDefault();
    const { href } = e.target;
    if (typeof href !== 'undefined') {
      window.open(href, '_blank');
    }
  }

  filteredDataItems () {
    const { defSort, defStatus, par_items } = this.state;
    const items = deepClone(par_items);
    let filteredItems = defStatus == 'all' ? items : items.filter((item) => item.dataWs.status == defStatus);

    switch (defSort.toString()) {
      case 'asc':
        filteredItems = filteredItems.sort((a, b) => a.dataWs.name.localeCompare(b.dataWs.name));
        break;
      case 'desc':
        filteredItems = filteredItems.sort((a, b) => b.dataWs.name.localeCompare(a.dataWs.name));
        break;
      case 'priority':
        filteredItems = filteredItems.sort((a, b) => a.dataWs.priority - b.dataWs.priority);
        break;
      case 'startDate':
        filteredItems = filteredItems.sort((a, b) => a.dataWs.start_date - b.dataWs.start_date);
        break;
      case 'endDate':
        filteredItems = filteredItems.sort((a, b) => a.dataWs.target_date - b.dataWs.target_date);
        break;
      default:
        break;
    }
    const ele = document?.querySelector('.countWorkstreamList');
    if (ele) {
      const wsTotalCount = ele.getAttribute('data-count');
      const innerHtml = ele.innerHTML?.split(' ')?.pop();
      const filteredItemsLength = filteredItems?.length ?? 0;
      if (wsTotalCount > 0) {
        ele.innerHTML = `${filteredItemsLength} of ${wsTotalCount} ${innerHtml}`;
      }
    }
    return filteredItems;
  }

	onRowHover(rowId) {
    this.setState({ hoveredRowId: rowId });
  }

  onRowLeave() {
    this.setState({ hoveredRowId: null });
  }

  onArchive({id, status, name}) {
		showLoaderWidget($('#content'));
    $.post(`${wbConfig.baseUrl}/tag/archiveWS`, {
      wsid: id,
			status: status === "0" ? "1" : "0",
    }).done((data) => {
			// Reload the component by updating the state
      const updatedItems = this.state.par_items.map((item) => {
        if (item.dataWs.id === id) {
          item.dataWs.status = status === "0" ? "1" : "0"; // Toggle the status
        }
        return item;
      });
			toastr.success(`${name} Workstream ${status === "0" ? "unarchived" : "archived"}`);
      this.setState({ par_items: updatedItems });
			removeLoaderWidget();
		}).catch((error) => {
			console.error('Error during archive/unarchived operation:', error);
      removeLoaderWidget();
			toastr.error(`Unable to ${status === "0" ? "unarchived" : "archived"} ${name} Workstream `);
		});
  }

  render() {
    const { t } = this.props;
    const {
      popupShow, defSort, defStatus
    } = this.state;
    const filteredItems = this.filteredDataItems();

    return (
      <div className="teamSummery summeryNarative">
        <div style={{ display: 'flex', gap: '10px' }}>
          <TeamWorkstreamFilterDropdown
            name="sort"
            label="Sort"
            value={defSort}
            onChange={this.onChangeWsSorting}
            options={TeamWsSortOptions}
          />
          <TeamWorkstreamFilterDropdown
            name="show"
            label="Show"
            value={defStatus}
            onChange={this.onChangeStatus}
            options={TeamWsStatusOptions}
          />
        </div>
        {
          !filteredItems?.length
            ? <div style={{ margin: '20px 0px', fontSize: '14px' }}>{t("No workstreams fit the filter criteria")}.</div>
            : filteredItems.map((item, index) => (

            <div 
							className="narativeRow" 
							key={item.dataWs.id} 
							role="row" tabIndex="0" 
							aria-label={item.dataWs.name}
							onMouseEnter={() => this.onRowHover(item.dataWs.id)}
            	onMouseLeave={this.onRowLeave}
						>

              <div className="narativecol wsProgress">
                <div className={`ws-pre-wrapper ${this.clickable(item.dataWs.canEditAttribute)}`} style={{ paddingBottom: '0px' }}>
                  <div className="ws-persenage"><BarChartComp count={item.dataWs.progress} color={item.dataWs.color} radius={18} width={43} height={43} /></div>
                </div>
              </div>

              <div className={`narative_border_${item.dataWs.id}`}>
                <div className="narativecol nameAndprogress border_bottom">
                  <div className="ws-name-wrapper ">
                    <div className="ws-name" data-testid="ws-name">
                      <div title={item.dataWs.name} className="ws-name-text truncate3  clickable" onClick={e => this.wsNameClick(item.dataWs.id, e)} dangerouslySetInnerHTML={WbMarkdownHtml(item.dataWs.name)} />
                    </div>
                    <div className="ws-lead-name truncateText">
                      {' '}
                      {item.dataWs.leadName}
                    </div>
                  </div>
                </div>


                <div className="narativecol statusCount border_bottom">

                                    <IconWrapper className="wsRed">
                                      <IconCountComp
                                        count={item.dataMisc.red}
                                        iconPath={getAiTypeActionAttributeValueIcon('rag', RAG_RED)}
                                        imgWidth="12"
                                        imgHeight="12"
                                      />
                                    </IconWrapper>

                  <div className="WsLate">
                    <IconCountComp count={item.dataMisc.late} iconPath="late" imgWidth="9" imgHeight="10" />
                  </div>

                                    <IconWrapper className="wsDoing">
                                      <IconCountComp
                                        count={item.dataMisc.doing}
                                        iconPath={getAiTypeActionAttributeValueIcon('state', STATE_DOING)}
                                        imgWidth="12"
                                        imgHeight="12"
                                      />
                                    </IconWrapper>
                  </div>


                <div className="narativecol progressSec border_bottom">
                  <div className="inlineBlock wsSelectedPace sortClick" data-url={item.dataWs.pace}>
                    <div className={this.clickable(item.dataWs.canEditAttribute)} onClick={() => this.popupClick(item.dataWs, 'pace')}>
                      {item.dataWs.paceText}
                    </div>
                    {item.dataWs.canEditAttribute && (popupShow.indexOf(`pace_${item.dataWs.id}`) > -1) && <ChangePace selectPace={this.selectPace} wsid={item.dataWs.id} t={t}/>}
                  </div>

                  <div className="wshealthVal sortClick">
                    <div className={this.clickable(item.dataWs.canEditAttribute)} onClick={() => this.popupClick(item.dataWs, 'health')}>
                      <div className="inlineBlock heathVal">{item.dataWs.healthName}</div>
                      <img className="wsEditPopupHealth" width="10px" src={`${wbConfig.imageCdnUrl}/images/icons/${item.dataWs.healthImage}`} />
                    </div>
                    {item.dataWs.canEditAttribute && (popupShow.indexOf(`health_${item.dataWs.id}`) > -1) && <ChangeHealth selectHealt={this.selectHealt} wsid={item.dataWs.id} t={t}/>}
                  </div>

                  <div className="inlineBlock wsPriorities sortClick">
                    <div className={this.clickable(item.dataWs.canEditAttribute)} onClick={() => this.popupClick(item.dataWs, 'Priorities')}>
                      <div className="inlineBlock wsSelectedPriorities" data-url={item.dataWs.priority}>{item.dataWs.priorityText}</div>
                    </div>
                    {item.dataWs.canEditAttribute && (popupShow.indexOf(`Priorities_${item.dataWs.id}`) > -1) && <ChangePriority selectPriority={this.selectPriority} wsid={item.dataWs.id} />}

                  </div>
                </div>


                <div className="narativecol dateRange border_bottom">
                  <div className="wsDate">
                    <div className={`narative_start_date ${this.clickable(item.dataWs.canEditAttribute)}`} onClick={e => this.clickDate(item.dataWs.id, item.dataWs.target_date, 'startDate_', item.dataWs.canEditAttribute)}>
                      { item.dataWs.start_date
                                          && <input type="text" className={`inputStartDate ${this.clickable(item.dataWs.canEditAttribute)}`} name="startDate" id={`startDate_${item.dataWs.id}`} defaultValue={$.datepicker.formatDate('M dd, yy', new Date(item.dataWs.start_date * 1000))} />
                                      }
                      { (!item.dataWs.start_date)
                                          && (
                                          <div className={`nara_no_start calenderIcon ${this.clickable(item.dataWs.canEditAttribute)}`}>
                                            <input type="text" className="inputStartDate_hide " name="startDate" id={`startDate_${item.dataWs.id}`} />
                                            <div className="noDate_">Start</div>
                                            <div className="icon_wsSummery"><ImgIconComp class="date_grey" id="date_grey" width="15" height="15" /></div>
                                          </div>
                                          )
                                      }
                    </div>

                    <div className="dataSaprator">-</div>

                    <div className={`narative_end_date ${this.clickable(item.dataWs.canEditAttribute)}`} onClick={e => this.clickDate(item.dataWs.id, item.dataWs.start_date, 'endDate_', item.dataWs.canEditAttribute)}>
                      { (item.dataWs.target_date)
                                          && <input className={`inputEndDate ${this.clickable(item.dataWs.canEditAttribute)}`} type="text" wsid={item.dataWs.id} name="endDate" id={`endDate_${item.dataWs.id}`} defaultValue={$.datepicker.formatDate('M dd, yy', new Date(item.dataWs.target_date * 1000))} />
                                      }
                      { (!item.dataWs.target_date)
                                          && (
                                          <div className={`nara_no_end calenderIcon ${this.clickable(item.dataWs.canEditAttribute)}`}>
                                            <input className="inputEndDate_hide " type="text" name="endDate" id={`endDate_${item.dataWs.id}`} />
                                            <div className="noDate_">End</div>
                                            <div className="icon_wsSummery"><ImgIconComp class="date_grey" id="date_grey" width="15" height="15" /></div>
                                          </div>
                                          )
                                      }
                    </div>

                  </div>
                </div>

                <div className="narativecol border_bottom notCol">
                  <div className="note">
                    <ImgIconComp id={(!$.trim(item.dataWs.goal) ? 'details_grey' : 'details_blue')} width="10" height="10" />
                  </div>
                </div>

                <div className="narativecol showNote border_bottom" onClick={e => this.togleNote(item.noteShow, item.dataWs.id)}>
                  <div className="icon_arrow">
                    <div className={`arrow_down_${item.dataWs.id}`}>
                      <ImgIconComp class="arrow_down_gray" id="arrow_down_gray" width="10" height="8" />
                    </div>
                    <div className={`arrow_up_${item.dataWs.id}`} style={{ display: 'none' }}>
                      <ImgIconComp class="arrow_up_gray" id="arrow_up_gray" width="10" height="8" />
                    </div>
                  </div>
                </div>
								<div 
									className="narativecol border_bottom ws-archive" 
									title={item.dataWs.status !== "0" ? "Archive" : "Unarchive"} 
									style={{ visibility: item.dataWs.id === this.state.hoveredRowId && item.dataWs.canEditAttribute ? 'visible' : 'hidden' }}
								>
											<IconButton aria-label="Archive" onClick={() => this.onArchive({id: item.dataWs.id, status: item.dataWs.status, name: item.dataWs.name})}>
												{item.dataWs.status !== "0" ? <ArchiveOutlinedIcon /> : <UnarchiveOutlinedIcon />}
											</IconButton>
										</div>
              </div>

              <div className={`editNote editNote_${item.dataWs.id}`} style={{ display: 'none' }}>
                <div className={`border_bottom noteDiv noteDiv_${item.dataWs.id}`}>
                  <div onClick={e => this.goalTextClick(e, item.dataWs.goal)} className="goalEdit" id={`editDisc_${item.dataWs.id}`} dangerouslySetInnerHTML={WbMarkdownHtml(item.dataWs.goal, true)} />
                  {
                              this.goalShowDiv(item.dataWs.goal, item.dataWs.canEditAttribute, item.dataWs.id)
                          }


                </div>
              </div>
            </div>
            ))
        }
      </div>
    );
  }
}
/* end narative comp */

/* popup  comp */
class ViewWsPopupComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTasks: this.props.chartTasks,
      chageTeamLeadPopup: false,
      healthPopup: false,
      pacePopup: false,
      priorityPopup: false,
      startDatePopup: false,
      endDatePopup: false,
      item: this.props.item,
      ckeditor: false,
      wsNameClick: false,
      changeLeadName: {},
      actionDone: false,
      paceText: this.props.item.dataWs.paceText,
      pace: this.props.item.dataWs.pace,
      healthName: this.props.item.dataWs.healthName,
      healthImage: this.props.item.dataWs.healthImage,
      health: this.props.item.dataWs.health,
      priorityText: this.props.item.dataWs.priorityText,
      priority: this.props.item.dataWs.priority,
      target_date: this.props.item.dataWs.target_date,
      start_date: this.props.item.dataWs.start_date,
      leadName: this.props.item.dataWs.leadName,
      leadImagePath: this.props.item.dataWs.leadImagePath,
      owner: this.props.item.dataWs.owner,
      goal: this.props.item.dataWs.goal,
      name_truncate: this.props.item.dataWs.name_truncate,
      wsName: this.props.item.dataWs.name,
      displayText: { display: 'block' },
      displayTextEdit: { display: 'none' },
      selTab: 'descTab',
      customAttribute: this.props.item.dataWs.custom_attribute,
    };
    this.selectHealt = this.selectHealt.bind(this);
    this.selectPriority = this.selectPriority.bind(this);
    this.selectPace = this.selectPace.bind(this);
    this.selectDueDate = this.selectDueDate.bind(this);
    this.selectStartDate = this.selectStartDate.bind(this);
    this.selectLead = this.selectLead.bind(this);
    this.closeWsPopup = this.closeWsPopup.bind(this);
    this.teamLeadPopupClick = this.teamLeadPopupClick.bind(this);
    this.healthPopupClick = this.healthPopupClick.bind(this);
    this.submitWsProps = this.submitWsProps.bind(this);
    this.cancelWsProps = this.cancelWsProps.bind(this);
    this.pacePopupClick = this.pacePopupClick.bind(this);
    this.priorityPopupClick = this.priorityPopupClick.bind(this);
    this.updateGoal = this.updateGoal.bind(this);
    this.urlify = this.urlify.bind(this);
    this.clickStartDate = this.clickStartDate.bind(this);
    this.clickEndDate = this.clickEndDate.bind(this);
    this.cKeditorLoad = this.cKeditorLoad.bind(this);
    this.selectWsName = this.selectWsName.bind(this);
    this.wsNameEditing = this.wsNameEditing.bind(this);
    this.handlePopupClick = this.handlePopupClick.bind(this);
    this.getWsProgressColor = this.getWsProgressColor.bind(this);
    this.remainingDays = this.remainingDays.bind(this);
    this.onWsNameChange = this.onWsNameChange.bind(this);
    this.updateCustomAttribute = this.updateCustomAttribute.bind(this);
    this.syncNowFunction = this.syncNowFunction.bind(this);
    this.deleteWs = this.deleteWs.bind(this);
  }

  componentDidMount() {
    showLoaderWidget($('#content'));
    window.addEventListener('click', this.handlePopupClick, true);
    this.datepicker = $('#wsTeamStartDate');
    let minDate = '';
    if (this.state.target_date) {
      var d = new Date();
      var date = new Date(this.state.target_date * 1000 + d.getTimezoneOffset() * 60000);
      minDate = (`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`);
    }
    var _this = this;
    if (this.state.item.dataWs.canEditAttribute) {
      $(this.datepicker).datepicker({
        maxDate: minDate,
        showAnim: 'slide',
        dateFormat: 'mm/dd/yy',
        onSelect(date) {
          $('#wsTeamEndDate').datepicker('option', 'minDate', date);
          _this.selectStartDate(date);
        },
        onChangeMonthYear(year, month, inst) {
          const buttonPane = $(inst.input).datepicker('widget');
          $(buttonPane).find('button.newStyleForDatePicker').remove();
          setTimeout(() => {
            const btn = $('<button class=" clearstyles newStyleForDatePicker" type="button">Clear</button>');
            btn
              .off('click')
              .on('click', () => {
                $.datepicker._clearDate(inst.input);
              });
            if ($('.wbmodal-datepicker .newStyleForDatePicker').length == 0) {
              btn.appendTo(buttonPane);
            }
          }, 1);
        },
        beforeShow(input) {
          $('#ui-datepicker-div').addClass('dataTimePicker wbmodal-datepicker');
          setTimeout(() => {
            const buttonPane = $(input).datepicker('widget');
            const btn = $('<button class=" clearstyles newStyleForDatePicker" type="button" >Clear</button>');
            btn
              .off('click')
              .on('click', () => {
                $.datepicker._clearDate(input);
              });
            if ($('.wbmodal-datepicker .newStyleForDatePicker').length == 0) {
              btn.appendTo(buttonPane);
            }
          }, 1);
        },
      });
    }
    this.datepicker = $('#wsTeamEndDate');
    var _this = this;
    if (this.state.item.dataWs.canEditAttribute) {
      let maxDate = '';
      if (this.state.start_date) {
        var d = new Date();
        var date = new Date(this.state.start_date * 1000 + d.getTimezoneOffset() * 60000);
        maxDate = (`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`);
      }
      $(this.datepicker).datepicker({
        showAnim: 'slide',
        dateFormat: 'mm/dd/yy',
        minDate: maxDate,
        onSelect(date) {
          $('#wsTeamStartDate').datepicker('option', 'maxDate', date);
          _this.selectDueDate(date);
        },
        onChangeMonthYear(year, month, inst) {
          const buttonPane = $(inst.input).datepicker('widget');
          $(buttonPane).find('button.newStyleForDatePicker').remove();
          setTimeout(() => {
            const btn = $('<button class=" clearstyles newStyleForDatePicker" type="button">Clear</button>');
            btn
              .off('click')
              .on('click', () => {
                $.datepicker._clearDate(inst.input);
              });
            if ($('.wbmodal-datepicker .newStyleForDatePicker').length == 0) {
              btn.appendTo(buttonPane);
            }
          }, 1);
        },
        beforeShow(input) {
          $('#ui-datepicker-div').addClass('dataTimePicker wbmodal-datepicker');
          setTimeout(() => {
            const buttonPane = $(input).datepicker('widget');
            const btn = $('<button class=" clearstyles newStyleForDatePicker" type="button" >Clear</button>');
            btn
              .off('click')
              .on('click', () => {
                $.datepicker._clearDate(input);
              });
            if ($('.wbmodal-datepicker .newStyleForDatePicker').length == 0) {
              btn.appendTo(buttonPane);
            }
          }, 1);
        },
      });
    }

    /* for change team lead info */
    const urlappent = '&canAddNonMember=false&canAddNonMemberDefaultTeam=false&showNonMemberAdd=false&self=false&showOrgUsers=false';
    const JsonResponse = '&returnJson=true';
    if (typeof wbConfig.baseUrl !== 'undefined') {
      showLoaderWidget($('#content'));
      $.ajax({
        url: `${wbConfig.baseUrl}/activity/ViewAssigniList?board=${this.state.item.wsid ?? this.state.item.wsId}${urlappent}${JsonResponse}`,
        type: 'get',
      })
        .done((response) => {
          _this.setState({
            changeLeadName: response.data,
          });
          removeLoaderWidget();
        });
    }
    if (this.state.item.dataWs.canEditAttribute && !this.state.ckeditor) {
      this.cKeditorLoad();
    }
    removeLoaderWidget();
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handlePopupClick, true);
  }

  remainingDays(startDate, endData) { // calcualting remaing week
    if ((!startDate) || (!endData)) {

    } else {
      const today = moment();
      const start = moment.unix(startDate);
      const end = moment.unix(endData);
      const tot_days = (end.diff(start, 'days')) % 7;
      let tot_weeks = end.diff(start, 'weeks');
      const rem_days = end.diff(today, 'days') + 1;
      let rem_weeks = parseInt(rem_days / 7);// end.diff(today, 'weeks');
      rem_weeks = (rem_weeks < 0) ? 0 : rem_weeks;
      tot_weeks = (tot_weeks < 0) ? 0 : tot_weeks;
      const return_ = `${rem_weeks} of ${tot_weeks}${(tot_days != 0) ? `.${tot_days}` : ' '} Weeks Remaining`;
      return return_;
    }
  }

  selectHealt(healthName, healthImage, health) {
    this.setState({
      healthName,
      healthImage,
      health,
      actionDone: true,
      healthPopup: false,
    });
  }

  selectPriority(proText, proValue) {
    this.setState({
      priorityText: proText,
      priority: proValue,
      actionDone: true,
      priorityPopup: false,
    });
  }

  selectPace(paceText, paceVal) {
    const _this = this;
    _this.setState({
      paceText,
      pace: paceVal,
      actionDone: true,
      pacePopup: false,
    });
  }

  selectDueDate(date) {
    let date_;
    const s = date.split('/');
    if (s.length > 1) {
      date_ = new Date(s[2], s[0] - 1, s[1]).getTime() / 1000;
    }
    this.setState({
      target_date: date_,
      actionDone: true,
    });
  }

  selectStartDate(date) {
    let date_;
    const s = date.split('/');
    if (s.length > 1) {
      date_ = new Date(s[2], s[0] - 1, s[1]).getTime() / 1000;
    }
    this.setState({
      start_date: date_,
      actionDone: true,
    });
  }

  selectLead(name, lastName, pic, leadId) {
    this.setState({
      leadName: name + lastName,
      leadImagePath: pic,
      owner: leadId,
      actionDone: true,
      chageTeamLeadPopup: false,
    });
  }

  onWsNameChange(e) {
    let wsName = $('#edtWsNameText').val();
    if (wsName.length > 128) {
      e.preventDefault();
    }

    if (wsName) {
      wsName = wsName.replace(/&amp;/g, '&');
      wsName = wsName.replace(/&nbsp;/g, ' ');
      this.setState({
        wsName,
      });
    }
  }

  updateCustomAttribute(customAttribute) {
    this.setState({
      customAttribute,
      actionDone: true,
    });
  }

  deleteWs(id) {

  }

  closeWsPopup() {
    this.mountId = document.getElementById('wsEditPopup');
    ReactDOM.unmountComponentAtNode(this.mountId);
    $('#wsEditPopup').dialog('close');
  }

  syncNowFunction() {
    const { items } = this.state;
    const ws_id = this.state.item.id;
    if (ws_id == '' || typeof (ws_id) === undefined) {
      return false;
    }
    wsImportSyncData(ws_id);
  }

  teamLeadPopupClick() {
    const _this = this;
    setTimeout(() => _this.setState({
      chageTeamLeadPopup: true,
    }), 10);
  }

  healthPopupClick() {
    const _this = this;
    setTimeout(() => _this.setState({
      healthPopup: true,
    }), 10);
  }

  pacePopupClick() {
    const _this = this;
    setTimeout(() => _this.setState({
      pacePopup: true,
    }), 10);
  }

  priorityPopupClick() {
    const _this = this;
    setTimeout(() => _this.setState({
      priorityPopup: true,
    }), 10);
  }

  updateGoal(content) {
    content = urlify(content);
    this.setState({
      goal: content,
      actionDone: true,
    });
  }

  urlify(text) {
    if (text && typeof text !== 'undefined' && text.length > 0) {
      const urlRegex = /((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;
      return text.replace(urlRegex, "<a target='_blank' href='$1'>$1</a>");
    }
    return text;
  }

  clickStartDate(canEdit) {
    if (canEdit) {
      $('#wsTeamStartDate').datepicker('show');
    }
  }

  clickEndDate(canEdit) {
    if (canEdit) {
      $('#wsTeamEndDate').datepicker('show');
    }
  }

  cKeditorLoad() {
    const _this = this;
    if (this.state.item.dataWs.canEditAttribute && !this.state.ckeditor) {
      // $('.pencilImg').hide();
      this.setState({
        ckeditor: true,
      });
      const eleIdB = 'editDisc';
      CKEDITOR.disableAutoInline = true;
      CKEDITOR.timestamp = css_js_version_control;
      const wsGoalEditorV = CKEDITOR.replace(eleIdB, {
        extraAllowedContent: 'a(documentation);abbr[title];code',
        startupFocus: true,
        // removePlugins: 'magicline,liststyle,tabletools,scayt,contextmenu,elementspath,forms',
        extraPlugins: 'chkstrike,confighelper,linkclickable,autogrow',
        // uploadUrl: '/uploader/upload.php',
        autoGrow_onStartup: false,
        resize_enabled: false,
        height: '120px',
        autoGrow_maxHeight: 100,
        autoGrow_bottomSpace: 0,
        line_height: '8px',
        sharedSpaces: {
          top: 'top2',
        },
        fillEmptyBlocks: false,
        shiftEnterMode: CKEDITOR.ENTER_BR,
        enterMode: CKEDITOR.ENTER_BR,
        allowedContent: true,
        entities: false,
        basicEntities: false,
      });
      wsGoalEditorV.on('instanceReady', (ev) => {
        ev.editor.focus();
        const s = ev.editor.getSelection(); // getting selection
        let selected_ranges = s.getRanges(); // getting ranges
        let node = selected_ranges[0].startContainer; // selecting the starting node
        while (true) {
          const x = node.getNext();
          if (x == null) {
            break;
          }
          node = x;
        }
        s.selectElement(node);
        selected_ranges = s.getRanges();
        selected_ranges[0].collapse(false); //  false collapses the range to the end of the selected node, true before the node.
        s.selectRanges(selected_ranges); // putting the current selection there
      });
      wsGoalEditorV.on('change', () => {
        const content = wsGoalEditorV.getData();
        _this.updateGoal(content);
      });
    }
  }

  selectWsName() {
    var displayEdit;
    let display;
    const isEditable = $('#edtWsName').attr('data-status');
    if (isEditable == 'false') {
      $('#edtWsName').show();
      $('#edtWsNameText').hide();
      return;
    }
    var displayEdit = { display: 'block' };
    $('#edtWsName').hide();
    $('#edtWsNameText').show();

    const _this = this;
    setTimeout(() => _this.setState({
      actionDone: true,
      wsNameClick: true,
      displayTextEdit: displayEdit,
    }), 10);
  }

  wsNameEditing(e) {
    if (e.keyCode === 13) {
      document.execCommand('insertHTML', false, '<br><br>');
      document.execCommand('insertHTML', false, '<div></div>');
      return false;
    }
  }

  handlePopupClick(e) {
    if (!$('.wsEditProps').is(e.target) // if the target of the click isn't the container...
            && $('.wsEditProps').has(e.target).length === 0) {
      $('.pencilImg').show();
      let name = $('#edtWsName').html();
      if (name) {
        name = name.replace('<div>', '');
        name = name.replace('</div>', '');
        name = name.replace('<br>', '');
        if (name.length != 0) {
          this.setState({
            wsNameClick: false,
          });
        }
      }
      this.setState({
        chageTeamLeadPopup: false,
        healthPopup: false,
        priorityPopup: false,
        pacePopup: false,
        // ckeditor : false,

      });
    }

    if (this.state.item.dataWs.canEditAttribute) {
      if ($('#edtWsNameText').is(e.target) // if the target of the click isn't the container...
                && $('#edtWsNameText').has(e.target).length === 0) {
        this.setState({
          displayTextEdit: { display: 'block' },
          wsNameClick: true,
        });
      } else {
        const wsName = $('#edtWsNameText').val();
        if (wsName) {
          this.setState({
            displayTextEdit: { display: 'none' },
          });
          $('#edtWsName').show();
        } else {
          this.setState({
            wsNameClick: true,
          });
        }
      }
    }
  }

  getWsProgressColor(health) {
    let pColor;
    switch (health.toString()) {
      case '1' || 1 || '1':
        pColor = '#339933';
        break;
      case '2' || 2 || '2':
        pColor = '#476C89';
        break;
      case '3' || 3 || '3':
        pColor = '#db3a1b';
        break;
      default:
        pColor = '#476C89';
        break;
    }
    return pColor;
  }

  /* Trigger when save click */
  submitWsProps(e) {
    if (this.state.actionDone == false) {
      this.mountId = document.getElementById('wsEditPopup');
      if (this.mountId) {
        ReactDOM.unmountComponentAtNode(this.mountId);
      }
      $('#wsEditPopup').dialog('close');
      return false; // if noting is chaged no need to save
    }
    if (CKEDITOR.instances.editDisc) {
      CKEDITOR.instances.editDisc.destroy();
      this.setState({
        ckeditor: false,
      });
      $('.pencilImg').show();
    }
    const _this = this;
    const { id } = this.props.item.dataWs;
    let name = $('#edtWsName').html();
    let start_date = $('#wsTeamStartDate').val();
    let target_date = $('#wsTeamEndDate').val();
    const { leadName } = this.state;
    const { leadImagePath } = this.state;
    const { owner } = this.state;
    const { paceText } = this.state;
    const { pace } = this.state;
    const { healthName } = this.state;
    const { healthImage } = this.state;
    const { health } = this.state;
    const color = this.getWsProgressColor(_this.state.health);
    const { priorityText } = this.state;
    const { priority } = this.state;
    const { goal } = this.state;
    let name_truncate = '';
    const { lastName } = this.state;
    const { firstName } = this.state;
    name = name.replace('<div>', '');
    name = name.replace('</div>', '');
    const edtWsNameText = $('#edtWsNameText').val();
    if (name == '<br>' || name.length == 0 || edtWsNameText.length == 0) {
      $('#edtWsName').trigger('focus');
      return false;
    }
    if (name.length >= 23) {
      name_truncate = `${name.substr(0, 23)}...`;
    } else {
      name_truncate = name;
    }
    name = name.replace(/&amp;/g, '&');
    name = name.replace(/&nbsp;/g, ' ');
    const dateHash = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      Jun: 6,
      Jul: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };
    if (start_date) {
      let date_;
      var s = start_date.split(', ');
      var s1 = s[0].split(' ');
      var month = dateHash[s1[0]] - 1;
      if (s.length > 1) {
        date_ = new Date(s[1], month, s1[1]).getTime() / 1000;
        date_ -= (new Date(s[1], month, s1[1]).getTimezoneOffset() * 60);
      }
      start_date = date_;
    } else {
      start_date = '';
    }
    if (target_date) {
      let date_;
      var s = target_date.split(', ');
      var s1 = s[0].split(' ');
      var month = dateHash[s1[0]] - 1;
      if (s.length > 1) {
        date_ = new Date(s[1], month, s1[1]).getTime() / 1000;
        date_ -= (new Date(s[1], month, s1[1]).getTimezoneOffset() * 60);
      }
      target_date = date_;
    } else {
      target_date = '';
    }

    let invalid;
    const startDate = start_date;
    const targetDate = target_date;
    /* save updated values in DB */
    showLoaderWidget($('#content'));
    const { customAttribute } = this.state;
    const customAttributeModified = [];
    if (customAttribute.length) {
      customAttribute.map((item) => {
        item.attributes.map((filed) => {
          const selectItems = {
            id: filed.id,
            value: filed.ca_value,
          };
          customAttributeModified.push(selectItems);
        });
      });
    }
    const team_id = $('.editHead').attr('id');
    const param = {
      id, name, owner, start_date, target_date, health, priority, pace, goal, team_id, customAttribute: customAttributeModified,
    };
    const paramObj = {
      id, name, owner, user_id: owner, owner_firstname: firstName, owner_lastname: lastName, owner_picture: leadImagePath, start_date, target_date, health, priority, pace, goal, team_id,
    };
    $.post(`${wbConfig.baseUrl}/activity/updateAllWsAttribute`, param, function (data, status) {
      if (data.error) {
        this.mountId = document.getElementById('wsEditPopup');
        if (this.mountId) {
          ReactDOM.unmountComponentAtNode(this.mountId);
        }
        $('#wsEditPopup').dialog('close');
        removeLoaderWidget();
        return false;
      }
      _this.setState({
        actionDone: false,
      });
      /* update redux comp */
      // _this.props.actions.BoardWsDataUpate(paramObj);
      WsNameChange({ id, name, name_truncate });
      WsOwnerChange({ id, owner });
      WsLeadChange({
        id, leadName, leadImagePath,
      });
      WsStartDateChange({ id, startDate: start_date, chartUpdate: true });
      WsEndDateChange({ id, endDate: target_date, chartUpdate: true });
      WsChartDateInvalid({
        id, invalid, startDate, endDate: targetDate, ws_target_date: target_date,
      });
      WsHealthChange({
        id, health, healthName, healthImage, color,
      });
      WsPriorityChange({ id, priority, priorityText });
      WsPaceChange({ id, pace, paceText });
      WsGoalChange({ id, goalData: goal });

      const block = $('.block-1-head').height();
      $('.gantt-chart-wrapper #gantt').height(block);
      $('.date-title-header').attr('height', 21);
      removeLoaderWidget();
      this.mountId = document.getElementById('wsEditPopup');
      if (this.mountId) {
        ReactDOM.unmountComponentAtNode(this.mountId);
      }
      $('#wsEditPopup').dialog('close');
      const wsLiObj = $(`.workstreamLeftCol .uiMenu li.workstreamRender#workstream_${id}`);
      const wsName = name;
      let wsNameModified = wsName;
      if ($(wsLiObj).hasClass('retiredStreamsWs')) {
        wsNameModified = `${wsNameModified}: ${$(wsLiObj).attr('data-tname')}`;
      }
      wsNameModified = wsNameModified.replace(/&amp;/g, '&');
      wsNameModified = wsNameModified.replace(/&nbsp;/g, ' ');
      if ($(wsLiObj).find('img').length) {
        $(wsLiObj).html(`<img width="10px" height="8px" src="${wbConfig.baseUrl}/images/icons/widget/total_done.png"> ${wsNameModified}`).attr('title', wsNameModified);
      } else {
        $(wsLiObj).text(wsNameModified).attr('title', wsNameModified);
      }
      if (typeof _this.props.saveCallback === 'function') {
        _this.props.saveCallback(id);
      }
    });
  }

  cancelWsProps() {
    this.mountId = document.getElementById('wsEditPopup');
    if (this.mountId) {
      ReactDOM.unmountComponentAtNode(this.mountId);
    }
    $('#wsEditPopup').dialog('close');
  }

  render() {
    const { t } = this.props;
    const items = this.state.item;
    const { canEditAttribute } = this.state.item.dataWs;
    const left = {
      float: (canEditAttribute && !this.state.ckeditor) ? 'left' : '',
    };
    const cursor = canEditAttribute ? 'clickable' : 'nonClickable';
    const EdtWsName = (this.state.wsNameClick && canEditAttribute) ? 'EdtWsName wsNameSelect' : 'EdtWsName';
    const teamNames = this.state.changeLeadName;
    const { paceText } = this.state;
    const { pace } = this.state;
    const { healthName } = this.state;
    const healthImage = `/images/icons/${this.state.healthImage}`;
    const { health } = this.state;
    // let color = this.getWsProgressColor(this.health);
    const { priorityText } = this.state;
    const { priority } = this.state;
    const { target_date } = this.state;
    const { start_date } = this.state;
    const { leadName } = this.state;
    const { leadImagePath } = this.state;
    const { owner } = this.state;
    const { goal } = this.state;
    const { wsName } = this.state;
    const { displayText } = this.state;
    const { displayTextEdit } = this.state;
    const team_id = this.state.item.dataTeam.id;
    const ws_id = this.state.item.dataWs.id;
    const is_extern = this.state.item.dataWs.is_extern != 0;
    const { externalAppName } = this.state.item.dataWs;
    const { extAppLinkName } = this.state.item.dataWs;
    const extAppLable = (externalAppName != '') ? `${externalAppName} Import: ${extAppLinkName}` : '';
    const showSync = !!((is_extern == true && canEditAttribute == true));
    const boxtextWidth = (showSync == true) ? '68%' : '97%';
    $('.deleteWsPage').attr('has_action', 'true');
    const { customAttribute } = this.state;
    return (
      <div className="wsEditWrapper">
        <form id="wsPrpsEdit">
          <div className="editHead" id={team_id}>
            <div className="boxs headTextLine boxtextWidth" style={{ width: boxtextWidth }}>
              <div className="aiEditPageTitleCellddd">
                <div id="edtWsName" data-status={canEditAttribute} className="EdtWsName displayInline" onClick={this.selectWsName}>{wsName}</div>
                {canEditAttribute
                                            && (
                                            <textarea
                                              maxLength="128"
                                              id="edtWsNameText"
                                              style={displayTextEdit}
                                              className={EdtWsName}
                                              name="goal"
                                              tabIndex="1"
                                              onChange={this.onWsNameChange}
                                              defaultValue={wsName}
                                            />
                                            )
                                        }

              </div>
              { !is_extern
                                      && <div className="remaining">{this.remainingDays(start_date, target_date)}</div>
                                    }
              { is_extern
                                        && <div className="extAppName truncateText">{extAppLable}</div>
                                    }
            </div>

            { showSync
                                && (
                                <div className="syncNow displayInline" onClick={this.syncNowFunction}>
                                  <div className="syncImage"><img style={{ padding: '0px 5px' }} src={`${wbConfig.baseUrl}/images/icons/sync_ws_blue.png`} /></div>
                                  <div className="syncNowLable">{t("Synch Now")}</div>
                                </div>
                                )
                            }
            { showSync
                             && <div className="deleteWsPage" id={ws_id} wsid={ws_id} onClick={e => this.deleteWs(ws_id)}>{t("Delete Ws")}</div>
                            }
            <div className="closeWsPopup right clickable displayInline" onClick={this.closeWsPopup}>
              <ImgIconComp id="close" />
            </div>
          </div>
          <div style={{ clear: 'both' }} />
          <div className="wsEdtProps">
            <div className="wsEdtPropsWrpper">

              <div className="wsEditLaedDetails">
                <div onClick={this.teamLeadPopupClick} className="teamNameDivWrapper">
                  <div className="">
                    <div className="wsEditHeadText leadLable">{t("LEAD")}</div>
                    <div className="wsEditImageWrapper" id="teamOwner" data-url={owner}>
                      <img className="wsEditLaedImage fitProfileImage" src={leadImagePath} border="0" width="40" height="40" />
                    </div>
                    <div className={`wsEditLeadName wsEditLables ${cursor}`}>{leadName}</div>
                  </div>

                </div>
              </div>
              <div id="showTeamLeadPopup" className="wsEditProps showTeamLeadPopup">
                {canEditAttribute && this.state.chageTeamLeadPopup && <ChageTeamLead selectLead={this.selectLead} item={items.dataWs.id} leadList={teamNames} />}
              </div>

              <div className="wsEditCalndDetails">
                <div className="wsEditStartDateWrapper">
                  <div className="wsEditHeadText">{t("START DATE")}</div>
                  <div className="" id="wsEditStartDate">
                    <input type="text" className={`wsEditStartDate discEdit ${cursor}`} name="start_date" id="wsTeamStartDate" defaultValue={start_date ? $.datepicker.formatDate('M dd, yy', new Date(start_date * 1000)) : 'M D, Y'} />
                  </div>
                  <div className={`wsEditStartImg ${cursor}`} onClick={e => this.clickStartDate(canEditAttribute)}><img src={`${wbConfig.imageCdnUrl}/images/icons/edit_images/due_grey.png`} /></div>

                </div>
                <div className="wsEditEndDateWrapper">
                  <div className="wsEditHeadText">{t("END DATE")}</div>
                  <div className="">
                    <input type="text" className={`wsEditEndDate discEdit ${cursor}`} name="end_date" id="wsTeamEndDate" defaultValue={target_date ? $.datepicker.formatDate('M dd, yy', new Date(target_date * 1000)) : 'M D, Y'} />
                  </div>
                  <div className={`wsEditEndImg ${cursor}`} onClick={e => this.clickEndDate(canEditAttribute)}>
                    {' '}
                    <img src={`${wbConfig.imageCdnUrl}/images/icons/edit_images/due_grey.png`} />
                  </div>
                </div>
              </div>

              <div className="wsEditPropsDetails">
                <div className="wsEditHealth">
                  <div className="wsEditHeadText">{t("HEALTH")}</div>
                  <div onClick={this.healthPopupClick}>
                    <div className={`wsEditLables wsEditHealthText ${cursor}`} id="wsEditHealthText" data-url={health} onClick={this.healthPopupClick}>
                      {healthName}
                    </div>
                    <div className="wsEditHealthImg">
                      <img src={wbConfig.imageCdnUrl + healthImage} border="0" width="10" height="10" />
                    </div>
                    <div className="clear" />

                  </div>
                  <div id="showHealth" className="wsEditProps">
                    {canEditAttribute && this.state.healthPopup && <ChangeHealth selectHealt={this.selectHealt} t={t}/>}
                  </div>
                </div>

                <div className="wsEditPriority">
                  <div className="wsEditHeadText">{t("PRIORITY")}</div>
                  <div className={`wsEditLables wsEditPriorityText ${cursor}`} id="wsEditPriority" data-url={priority} onClick={this.priorityPopupClick}>
                    {priorityText}
                    {' '}
                  </div>
                  <div id="showPriority" className="wsEditProps">
                    {canEditAttribute && this.state.priorityPopup && <ChangePriority selectPriority={this.selectPriority} />}
                  </div>
                </div>

                <div className="wsEditPeace">
                  <div className="wsEditHeadText">{t("PACE")}</div>
                  <div className={`wsEditLables wsEditPeaceText ${cursor}`} id="wsEditPeaceText" data-url={pace} onClick={this.pacePopupClick}>{paceText}</div>
                  <div id="showPacePopup" className="wsEditProps">
                    {canEditAttribute && this.state.pacePopup && <ChangePace selectPace={this.selectPace} t={t}/>}
                  </div>
                </div>

              </div>


            </div>

          </div>
          <div style={{ clear: 'both' }} />


          <div className="wsEdtDiscr">
            <div className="diescWrap descTab" onClick={e => this.selTab('descTab')}>
              <div className="wsEdtDiscHead wsEditLables ">{t("Description")}</div>
              {
                                        this.state.selTab == 'descTab'
                                          ? <div className="selTab" />
                                          : ''
                                    }
            </div>
            {
                                  customAttribute.length > 0 && (
                                  <div className="diescWrap customeAttrTap" onClick={e => this.selTab('customeAttrTap')}>
                                    <div className="wsEdtDiscHead wsEditLables ">{t("Custom Attributes")}</div>
                                    {
                                          this.state.selTab == 'customeAttrTap'
                                            ? <div className="selTab" />
                                            : ''
                                      }
                                  </div>
                                  )
                                }
            <div className="boderBottom" />

            {
                                    (this.state.selTab == 'descTab' && !canEditAttribute)
                                      ? (
                                        <div className="wsEdtDiscData discEdit ">
                                          <div dangerouslySetInnerHTML={WbMarkdownHtml(goal)} />
                                        </div>
                                      )
                                      : ''
                                }

            {
                                    (this.state.selTab == 'descTab' && canEditAttribute)
                                      ? (
                                        <div id="editDisc" style={{ display: 'none' }}>
                                          <div dangerouslySetInnerHTML={WbMarkdownHtml(goal)} />
                                        </div>
                                      )
                                      : ''
                                }


            {
                                    this.state.selTab == 'customeAttrTap' && customAttribute.length > 0
                                      ? (
                                        <div className="" id="customAttrDiv">
                                          <CustomeAttrDisplay customAttribute={customAttribute} updateCustomAttribute={this.updateCustomAttribute} canEditAttribute={canEditAttribute} />
                                        </div>
                                      )
                                      : ''
                                }
          </div>

          <div style={{ clear: 'both' }} />

          <div className="wsEdtButtons">
            {canEditAttribute
                                && (
                                <div className="wsEdtButtonsWrapper">
                                  <input
                                    className="btn_cancel"
                                    type="button"
                                    name="Cancel"
                                    defaultValue="Cancel"
                                    onClick={this.cancelWsProps}
                                  />
                                  <input
                                    className="btn_save"
                                    type="button"
                                    name="Save"
                                    defaultValue="Save"
                                    onClick={this.submitWsProps}
                                  />
                                </div>
                                )
                         }
          </div>
          <div style={{ clear: 'both' }} />
        </form>
      </div>

    );
  }
}

class ChangeHealth extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    const wsId = this.props.wsid;
    return (
      <div className="wsHealthList  showHealth">
        <div
          className="clickable healthVal"
          data-url={HEALTH_GOOD}
          onClick={() => this.props.selectHealt('GOOD', 'uptriangle.png', HEALTH_GOOD, wsId)}
        >
          <div className="inlineBlock healthValDiv">{t("GOOD")}</div>
          <img className="wsEditPopupHealth" width="10px" src={`${wbConfig.imageCdnUrl}/images/icons/uptriangle.png`} />
        </div>

        <div className="clickable healthVal" data-url={HEALTH_OK} onClick={() => this.props.selectHealt('OK', 'sidetriangle.png', HEALTH_OK, wsId)}>
          <div className="inlineBlock healthValDiv">{t("OK")}</div>
          <img className="wsEditPopupHealth" width="10px" src={`${wbConfig.imageCdnUrl}/images/icons/sidetriangle.png`} />
        </div>

        <div className="clickable healthVal" data-url={HEALTH_RISK} onClick={() => this.props.selectHealt('RISK', 'red-arrow.png', HEALTH_RISK, wsId)}>
          <div className="inlineBlock healthValDiv">{t("RISK")}</div>
          <img className="wsEditPopupHealth" width="10px" src={`${wbConfig.imageCdnUrl}/images/icons/red-arrow.png`} />
        </div>
      </div>
    );
  }
}

class ChangePriority extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const wsId = this.props.wsid;
    return (
      <div className="showPriority">
        <div
          className="inlineBlock clickable priorityVal"
          data-url={PORIORITY_P1}
          onClick={() => this.props.selectPriority('P1', PORIORITY_P1, wsId)}
        >
                        P1
        </div>
        <div
          className="inlineBlock clickable priorityVal"
          data-url={PORIORITY_P2}
          onClick={() => this.props.selectPriority('P2', PORIORITY_P2, wsId)}
        >
                        P2
        </div>
        <div
          className="inlineBlock clickable priorityVal"
          data-url={PORIORITY_P3}
          onClick={() => this.props.selectPriority('P3', PORIORITY_P3, wsId)}
        >
                        P3
        </div>
        <div
          className="inlineBlock clickable priorityVal"
          data-url={PORIORITY_P4}
          onClick={() => this.props.selectPriority('P4', PORIORITY_P4, wsId)}
        >
                        P4
        </div>
        <div
          className="inlineBlock clickable priorityVal"
          data-url={PORIORITY_P5}
          onClick={() => this.props.selectPriority('P5', PORIORITY_P5, wsId)}
        >
                        P5
        </div>
      </div>
    );
  }
}

class ChangePace extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    const wsId = this.props.wsid;
    return (
      <div className="showPacePopup">
        <div className="clickable paceVal" data-url={PACE_FAST} onClick={() => this.props.selectPace('FAST', PACE_FAST, wsId)}>
          <div className="inlineBlock paceValDiv">{t("FAST")}</div>
          <div className="inlineBlock">
            <img width="10px" className="paceValImg" src={`${wbConfig.imageCdnUrl}/images/icons/uptriangle.png`} />
          </div>
        </div>

        <div className="clickable paceVal" data-url={PACE_STEADY} onClick={() => this.props.selectPace('STEADY', PACE_STEADY, wsId)}>
          <div className="inlineBlock paceValDiv">{t("STEADY")}</div>
          <div className="inlineBlock">
            <img width="10px" className="paceValImg" src={`${wbConfig.imageCdnUrl}/images/icons/sidetriangle.png`} />
          </div>
        </div>

        <div className="clickable paceVal" data-url={PACE_SLOW} onClick={() => this.props.selectPace('SLOW', PACE_SLOW, wsId)}>
          <div className="inlineBlock paceValDiv">{t("SLOW")}</div>
          <div className="inlineBlock">
            <img width="10px" className="paceValImg" src={`${wbConfig.imageCdnUrl}/images/icons/downtriangle.png`} />
          </div>
        </div>

      </div>
    );
  }
}

class ChageTeamLead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userNames: [],
      currentUserId: null,
      modalBoxContianer: null,
      loading: true,
      content: this.props.leadList,
      searchText: '',
      initialItems: this.props.leadList,
      searchData: {},
    };
    this.searchText = this.searchText.bind(this);
    this.filteredData = this.filteredData.bind(this);
  }

  searchText(e) {
    const searchText = e.target.value;
    this.setState({
      searchText,
    });
    const _this = this;
    const wsId = this.props.item;
    let content;
    const term = searchText;
    const param = {};
    param.term = term;
    param.board = wsId;
    param.urlappent = '&canAddNonMember=false&canAddNonMemberDefaultTeam=false&showNonMemberAdd=false&self=false&showOrgUsers=false';
    param.JsonResponse = '&returnJson=true';
    if (term.length >= 2) {
      $.ajax({
        url: `${wbConfig.baseUrl}/activity/SearchViewAssigniList`,
        type: 'get',
        data: param,
      })
        .done((response) => {
          _this.setState({
            content: response.data,
            done: 1,
          });
          removeLoaderWidget();
        });
    }
    if (Object.keys(this.state.content).length > 0) {
      const filteredDataList = this.state.content.filter(this.filteredData);
      this.setState({
        content: filteredDataList,
      });
    }
  }

  filteredData(item) {
    const { searchText } = this.state;
    if (searchText) {
      const searchTextLowerCase = searchText.toLowerCase();
      const itemFirstName = item.name.toLowerCase();
      const itemLastName = item.lastName.toLowerCase();
      return itemFirstName.indexOf(searchTextLowerCase) !== -1 || itemLastName.indexOf(searchTextLowerCase) !== -1;
    }

    return true;
  }

  render() {
    const { t } = this.props;
    const userLists = this.state.content || [];
    const { noSelf } = this.state.content;
    const { uid } = this.state.content;
    const placeholder = t("Type a person's name to search ");

    return (
      <div className="changeLeadWrapper" id="changeLeadWrapper">
        <div className="searchSection">
          <div className="search_submit_div">
            <img id="searchTag_submit" title="Search for person's name" width="17px" height="16px" src={`${wbConfig.imageCdnUrl}/images/icons/main_menu/search.png`} />
          </div>
          <input className="leadSearchInputbox gbl-text-entry text-field" placeholder={placeholder} onChange={this.searchText} />
        </div>

        <div className="searchdata">
          {
                            this.state.done == 1 && userLists && userLists.map((item, index) => (
                              <div key={`owner_${item.id}`} className="memberNameSearch memberNameDiv" data-id={item.id} onClick={() => this.props.selectLead(item.name, item.lastName, item.pic, item.id)}>
                                <div className="namesWrap">
                                  <span className="memberName ">{ (item.id == uid && noSelf) ? t('Self') : item.name }</span>
                                  <span className="memberLastName">{ (item.id == uid && noSelf) ? ' ' : item.lastName}</span>
                                </div>
                              </div>
                            ))
                        }
        </div>
      </div>
    );
  }
}
/* popup comp end */